import * as angular from 'angular';
import {IController} from "angular";

export class AccountSchedulingProjectComponent implements IController {

  currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountSchedulingProject', {
    bindings: {},
    template: require('./account-scheduling-project.html').default,
    controller: AccountSchedulingProjectComponent
  });
